import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AlertBannerComponent } from 'alert-banner-lib';
import { MessageAction, MessageNotificationService } from 'message-notification-service-lib';
import { filter } from 'rxjs/operators';
import { HamburgerWrapperComponent } from './components/hamburger-wrapper/hamburger-wrapper.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  @ViewChild('alertbanner') alertBanner!: AlertBannerComponent;
  @ViewChild(HamburgerWrapperComponent) hamburgerWrapper: HamburgerWrapperComponent;

  constructor(
    private messageNotificationService: MessageNotificationService,
    private renderer: Renderer2,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.listenForMessages();
    this.bhCardOrWebapp();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => this.bhCardOrWebapp());
  }

  private listenForMessages(): void {
    this.messageNotificationService.message$.subscribe(({ message, action }) => {
      // setTimeout: alertBanner is undefined until AfterViewInit
      setTimeout(() => {
        if (action === MessageAction.SHOW) {
          this.alertBanner.show(message);
        } else if (action === MessageAction.HIDE) {
          this.alertBanner.hide(message);
        }
      }, 0);
    });
  }

  private isBhCard(): boolean {
    return new URLSearchParams(window.location.search).has('CorporationID');
  }

  private bhCardOrWebapp() {
    if (this.isBhCard()) {
      this.renderer.addClass(document.body, 'bh-card');
    } else {
      this.renderer.addClass(document.body, 'webapp');
    }
  }

}
